import { render, staticRenderFns } from "./BackofficePaciente.vue?vue&type=template&id=0e900e5e&scoped=true"
import script from "./BackofficePaciente.vue?vue&type=script&lang=ts"
export * from "./BackofficePaciente.vue?vue&type=script&lang=ts"
import style0 from "./BackofficePaciente.vue?vue&type=style&index=0&id=0e900e5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e900e5e",
  null
  
)

export default component.exports